<span class="relative flex flex-col w-full h-full">
    <div class="p-8 pb-6" mat-dialog-content>
        <ng-container>
            <div class="absolute top-0 right-0 pt-4 pr-4">
                <button (click)="close()" mat-icon-button>
                    <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                </button>
            </div>
        </ng-container>
        <ng-container>
            <div class="w-100 border-b pb-[10px]">
                <div class="sm:flex xs:block items-center">
                    <div class="sm:flex-initial xs:block xs:max-w-100 sm:max-w-30pr items-center max-w-[200px]">
                        <mat-icon class="icon-size-10 ml-[10px] text-primary" [svgIcon]="'heroicons_solid:library'" matPrefix></mat-icon>
                    </div>
                    <div class="sm:flex-initial xs:block xs:max-w-100 sm:max-w-70pr">
                        <div class="text-2xl sm:text-4xl font-bold truncate sm:ml-[20px] basic-fuse-gray-color">{{data.data.name}}</div>
                    </div>
                </div>
                @if (data?.data?.deregistrationDate) {
                <div class="flex flex-col my-3">
                    <div class="text-sm font-medium leading-none text-secondary">
                        {{ 'label_company_deregistered' | translate }}: {{ data.data.deregistrationDate | date:'dd.MM.yyyy' }}
                    </div>
                </div>
                }
            </div>
            <div class="float-left w-full mt-2 mb-2">
                <ng-container>
                    <div class="flex flex-row flex-wrap mt-2 mb-4 gap-x-6">
                        <div class="flex flex-col my-3">
                            <div class="text-sm font-medium leading-none text-secondary">{{ 'label_ssn' | translate }}</div>
                            <div class="mt-2 font-medium text-2xl leading-none">{{formatKennitala(data.data.idNumber)}}</div>
                        </div>
                        @if (data?.data?.boardChairmanSSN) {
                        <div class="flex flex-col my-3">
                            <div class="text-sm font-medium leading-none text-secondary">VSK númer</div>
                            <div class="mt-2 font-medium text-2xl leading-none">{{formatKennitala(data.data.vatNumberExtended)}}</div>
                        </div>
                        } @if (data?.data?.businessFormNew) {
                        <div class="flex flex-col my-3">
                            <div class="text-sm font-medium leading-none text-secondary">{{ 'label_operational_form' | translate }}</div>
                            <div class="mt-2 font-medium text-2xl leading-none">{{data.data.businessFormNew}}</div>
                        </div>
                        } @if (data?.data?.industryCode) {
                        <div class="flex flex-col my-3">
                            <div class="text-sm font-medium leading-none text-secondary">{{ 'label_industry' | translate }} (nr.)</div>
                            <div class="mt-2 font-medium text-2xl leading-none">{{data.data.industryCode}}</div>
                        </div>
                        } @if (data?.data?.boardChairmanName) {
                        <div class="flex flex-col my-3">
                            <div class="text-sm font-medium leading-none text-secondary">{{ 'label_board' | translate }}</div>
                            <div class="mt-2 font-medium text-2xl leading-none">{{data.data.boardChairmanName}}</div>
                        </div>
                        } @if (data?.data?.boardChairmanSSN) {
                        <div class="flex flex-col my-3">
                            <div class="text-sm font-medium leading-none text-secondary">{{ 'label_board_ssn' | translate }}</div>
                            <div class="mt-2 font-medium text-2xl leading-none">{{formatKennitala(data.data.boardChairmanSSN)}}</div>
                        </div>
                        } @if (data?.data?.recipientName) {
                        <div class="flex flex-col my-3">
                            <div class="text-sm font-medium leading-none text-secondary">{{ 'label_contact' | translate }}</div>
                            <div class="mt-2 font-medium text-2xl leading-none">{{data.data.recipientName}}</div>
                        </div>
                        } @if (data?.data?.recipientSSN) {
                        <div class="flex flex-col my-3">
                            <div class="text-sm font-medium leading-none text-secondary">{{ 'label_contact_ssn' | translate }}</div>
                            <div class="mt-2 font-medium text-2xl leading-none">{{formatKennitala(data.data.recipientSSN)}}</div>
                        </div>
                        }
                    </div>
                </ng-container>
                @if (data?.data?.address) {
                <mat-divider class="my-4"></mat-divider>
                <div class="text-xl font-bold truncate basic-fuse-gray-color">{{ 'label_address' | translate }}</div>
                <div class="mt-2 font-medium text-2xl leading-none">
                    {{data.data.address}}, {{data.data.postalCode}} {{data.data.place}}
                </div>
                <div class="flex flex-row flex-wrap mb-4 gap-x-6">
                    @if (data?.data?.legalDomicile) {
                    <div class="flex flex-col my-3">
                        <div class="text-sm font-medium leading-none text-secondary">Sveitarfélag / Lögheimili</div>
                        <div class="mt-2 font-medium text-2xl leading-none">{{data.data.municipality}} / {{data.data.legalDomicile}}</div>
                    </div>
                    }
                </div>
                }
            </div>
        </ng-container>
    </div>
</span>
